import { termsOfUse } from "../../assets/dummyData";
import styles from "./TermsPrivacy.module.css";

function TermsOfUse() {
    return ( 
        <div className={styles.container} dangerouslySetInnerHTML={{ __html: termsOfUse }} />
     );
}

export default TermsOfUse